import { MonitorOff, ShieldCheck } from "lucide-react";

const GoogleMark = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.6 5.4 2.7 13.2l7.8 6.1C12.4 13.4 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10 7.1-17z" />
    <path fill="#FBBC05" d="M10.5 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.3 0-11.6-3.9-13.5-9.3l-7.9 6.1C6.6 42.6 14.6 48 24 48z" />
  </svg>
);

// Google sign-in (Emergent-managed) for people; TV screens open a display link created in /admin instead.
export const ViewerGate = ({ displayInvalid = false }) => {
  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-page p-6" data-testid="viewer-login-gate">
      <div className="panel w-full max-w-sm p-8 fade-up">
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-flex items-center bg-coal rounded-lg px-2.5 py-1.5">
            <img src="/fora-logo.png" alt="FORA" className="h-5 w-auto" draggable={false} />
          </span>
          <div>
            <h1 className="font-bold text-xl leading-tight text-ink">Clients Live</h1>
            <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
              <ShieldCheck className="w-3 h-3" /> FORA team only
            </p>
          </div>
        </div>
        <button
          type="button"
          data-testid="google-login-button"
          onClick={google}
          className="w-full inline-flex items-center justify-center gap-3 rounded-lg border border-slate-300 bg-panel hover:border-slate-400 text-ink font-semibold py-3 transition-colors shadow-sm"
        >
          <GoogleMark /> Sign in with Google
        </button>
        <p className="text-[11px] text-slate-400 mt-3 text-center" data-testid="viewer-login-note">
          Use your FORA Google account (@master-fb.com) or an invited guest account.
        </p>
        {displayInvalid && (
          <div className="mt-4 rounded-lg border border-brand/30 bg-brand/5 px-3 py-2.5 text-xs text-brand flex items-start gap-2" data-testid="display-invalid-note">
            <MonitorOff className="w-4 h-4 shrink-0 mt-0.5" />
            <span>This screen's display link is no longer valid (revoked or incomplete). Create a new one in Admin → Display screens and send it to the screen again.</span>
          </div>
        )}
        <p className="text-[11px] text-slate-400 mt-4 text-center" data-testid="viewer-display-hint">
          TV / Videri screen? Open the display link from Admin → Display screens – no sign-in needed.
        </p>
      </div>
    </div>
  );
};
